import { CustomerProjectType } from '../../../customer-project-type.enum';

// Types with asphalt columns and the Asfalttotalen tab
export const ASPHALT_TYPES = [CustomerProjectType.maintenance, CustomerProjectType.regular];

// Types that fill n.v.t. for missing areas and Onbekend for empty wear layer/execution
export const GENERAL_TYPES = [CustomerProjectType.maintenance];

// Column keys that hold a date
export const DATE_KEYS = ['created_at', 'executed_at'];

// Asphalt layers on the Asfalttotalen tab: extra field key → label
export const ASPHALT_LAYERS = { toplayer: 'Toplaag', interlayer: 'Tussenlaag', bottomlayer: 'Onderlaag' };

// Fill colour per asphalt type on the Asfalttotalen tab
export const ASPHALT_TYPE_COLORS: Record<string, string> = {
    'AC-11 Surf': 'B7B7B7',
    'AC-11 Rood': 'E06666',
    'AC-08 Surf': '7F7F7F',
    'AC-08 Rood': 'CC4125',
    'AC-08 Beige': 'F9CB9C',
    'SMA 0/11': 'A4A4A4',
    'SMA 0/11 Rood': 'C0504D',
    'SMA 0/8': '808080',
    'SMA 0/8 Rood': '9C0006',
    'DESA Rood': 'A61C00',
    'AC-16 Bind': '999999',
    'AC-22 Bind': '666666',
    'AC-16 Base': '595959',
    'AC-22 Base': '434343',
    Frezen: 'D9D9D9',
    'Frezen toplaag': 'BFBFBF',
};

export interface WorkareaExcelColumn {
    header: string;
    // Werkvak field, 'extra.<field>', or a computed value: maps_url, width, length, surface
    key: string;
}

// Shared first columns (Klantnaam removed)
const ADDRESS_COLUMNS: WorkareaExcelColumn[] = [
    { header: 'Vaknr', key: 'number' },
    { header: 'Locatie URL', key: 'maps_url' },
    { header: 'Status', key: 'status_name' },
    { header: 'Straat', key: 'street' },
    { header: 'Huisnummer', key: 'housenumber' },
    { header: 'Postcode', key: 'zipcode' },
    { header: 'Plaats', key: 'place' },
    { header: 'Wegnummer', key: 'road_number' },
    { header: 'Commentaar', key: 'comments' },
];

const DATE_COLUMNS: WorkareaExcelColumn[] = [
    { header: 'Datum_Geschouwd', key: 'created_at' },
    { header: 'Datum_Uitgevoerd', key: 'executed_at' },
];

const ASPHALT_COLUMNS: WorkareaExcelColumn[] = [
    ...ADDRESS_COLUMNS,
    { header: 'breedte', key: 'width' },
    { header: 'lengte', key: 'length' },
    { header: 'oppervlakte_in_m2', key: 'surface' },
    { header: 'Klinkers', key: 'extra.klinkerfloor' },
    { header: 'Wapening', key: 'extra.reinforcementgrid' },
    { header: 'Toplaag', key: 'extra.toplayer' },
    { header: 'Tussenlaag', key: 'extra.interlayer' },
    { header: 'Onderlaag', key: 'extra.bottomlayer' },
    { header: 'Slijtlaag', key: 'extra.wearlayer' },
    { header: 'Uitvoering', key: 'extra.execution' },
    { header: 'Prioriteit', key: 'extra.genpriority' },
    { header: 'Weg_afzetting', key: 'extra.roadblock' },
    { header: 'Markering', key: 'extra.waymark' },
    { header: 'Werk_schade_type', key: 'extra.damage' },
    { header: 'Werk_schade_locatie', key: 'extra.location_damage' },
    ...DATE_COLUMNS,
];

// Columns per project type (without Klantnaam)
export const WORKAREA_EXCEL_COLUMNS: Record<CustomerProjectType, WorkareaExcelColumn[]> = {
    [CustomerProjectType.maintenance]: ASPHALT_COLUMNS,
    [CustomerProjectType.regular]: ASPHALT_COLUMNS,
    [CustomerProjectType.drillings]: [
        ...ADDRESS_COLUMNS,
        { header: 'latitude', key: 'lat' },
        { header: 'longitude', key: 'lng' },
        { header: 'Boorlocatie', key: 'extra.drillLocation' },
        { header: 'Rijstrook', key: 'extra.lane' },
        { header: 'Lengte boorkern', key: 'extra.drill_length' },
        { header: 'Laagdikte', key: 'extra.layerthickness' },
        { header: 'Boormeester', key: 'extra.driller' },
        { header: 'Soort boring', key: 'extra.drillingType' },
        { header: 'Soort fundering', key: 'extra.foundationType' },
        ...DATE_COLUMNS,
    ],
};
